import {GerepAPI_EE} from '../gerep/GerepAPI'

const prefix = ''

export const getListCompany = token => GerepAPI_EE.get(`${prefix}/listCompany`, null, token)

